import type { PropsWithChildren } from 'react'

import { Outlet } from '@remix-run/react'
import { useRootLoaderData } from '@/root.tsx'
import Navigation from '@/components/_sections/navigation/navigation'
import ScrollingSlider from '../_sections/collage/scrolling-slider'
import { Footer } from '../_sections/footer.tsx/footer'
import Row from './row'

type NavLink = {
	url: string
	title: string
}

export default function LPD({ children }) {
	// TODO: Location Chooser:
	// Get users location and set the location in local storage the closest restaurant location to them if it's within 20 miles or whatevers easy. If we can't easily get a location or they're further than 20 miles from the nearest location, set location to choose location.
	// Location chooser is in the header section so it'll get set based off of what's in local storage.
	// the serverside value will be the default location but will have to be updated on the client side.
	// TODO:

	return (
		<main className="lpd font-poppins relative flex w-full flex-col place-items-center items-stretch bg-background">
			<div className="flex h-screen flex-col justify-between">
				<Navigation />

				<div className="flex-1">{children}</div>

				<Footer />
			</div>
		</main>
	)
}
